var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-header'),_vm._m(0),_c('share-details')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('h1',{staticClass:"title is-capitalized has-text-centered",attrs:{"id":"shares-title"}},[_vm._v("\n            Shares\n        ")])])
}]

export { render, staticRenderFns }